import { Stack } from '@mui/material'
import isNil from 'lodash/isNil'
import { Request } from '@omnea-app/requests/requestsHttpClient'

const getPriorityIconColor = (priority: Request['derivedFields']['priority'] | undefined) => {
  const lowPriorityValues = ['LOWEST', 'LOW']
  const highPriorityValues = ['HIGHEST', 'HIGH']
  if (isNil(priority)) return '#E7E7ED' // Neutral Grey
  if (lowPriorityValues.includes(priority)) return '#7B61FF' // Purple
  if (highPriorityValues.includes(priority)) return '#FF6F00' // Red
  return '#FF9800' // Orange
}

interface Props {
  priority?: Request['derivedFields']['priority']
}

export const RequestPriorityIcon = ({ priority }: Props) => {
  const color = getPriorityIconColor(priority)

  return (
    <Stack
      sx={{
        bgcolor: color,
        borderRadius: 8,
        color,
        height: 18,
        width: 3,
      }}
    />
  )
}
